import { render, staticRenderFns } from "./LenzLawViz.vue?vue&type=template&id=013342f4&scoped=true"
import script from "./LenzLawViz.vue?vue&type=script&lang=js"
export * from "./LenzLawViz.vue?vue&type=script&lang=js"
import style0 from "./LenzLawViz.vue?vue&type=style&index=0&id=013342f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013342f4",
  null
  
)

export default component.exports